import React from 'react';

import { FilterButton as SharedFilterButton } from '../../../../shared/components/Filter';
import { FILTERS } from '../../constants';
import { useDecedentFilters } from '../../hooks';

const FilterButton = () => {
  const { activeFilters, clearFilters } = useDecedentFilters();

  return (
    <SharedFilterButton
      activeFilters={activeFilters}
      clearFilters={clearFilters}
      filters={FILTERS.decedent}
    />
  );
};

export default FilterButton;
